import React, { useCallback } from 'react';
import { S2SafeParsable } from 'libs/end-to-end/src/interfaces';
import { useDatabaseSchemaJsonEditor } from 'apps/sigma2-ui/src/data-wizard/lib/useDatabaseSchemaJsonEditor';
import { S2MonocoEditor } from 'apps/sigma2-ui/src/data-wizard/components/S2MonocoEditor';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { Modal } from 'apps/sigma2-ui/src/components/ui/Modal';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export const DatabaseSchemaJsonEditor = <T,>({
  currentModel,
  schema,
  onSaved,
  show,
  setShow,
}: {
  currentModel: T | null;
  schema: S2SafeParsable<unknown, T>;
  onSaved: (model: T) => void;
  show: boolean;
  setShow: (show: boolean) => void;
}) => {
  const language = useLanguage();

  const { onSaveClicked, editedJson, setEditedJson, currentErrorText } =
    useDatabaseSchemaJsonEditor({
      currentModel,
      schema,
      onSaved,
    });

  const onSaveClickedInModal = useCallback(() => {
    const saveSucceeded = onSaveClicked().success;
    if (saveSucceeded) {
      setShow(false);
    }
  }, [onSaveClicked, setShow]);

  return (
    <Modal
      show={show}
      onClose={() => setShow(false)}
      title={'Json Editor'}
      scrollable={true}
    >
      <Spacing
        direction={'vertical'}
        size={'md'}
        as={'div'}
        className={'scroll'}
      >
        <S2MonocoEditor
          language="json"
          code={editedJson}
          setCode={setEditedJson}
          disabled={false}
        />
        {currentErrorText && (
          <S2Typography
            translatedContent={language.dangerousUserInput({
              value: currentErrorText,
            })}
            variant={'body-7'}
            textColorVariant={'red-600'}
          />
        )}
        <Button
          behavior={{
            type: 'onClick',
            onClick: onSaveClickedInModal,
          }}
          text={'Save'}
        />
      </Spacing>
    </Modal>
  );
};
